export default __webpack_public_path__ + "static/nl-d2cd819d5d4861f79e464860b0bcdec8.svg";